import React, { useContext, useEffect } from 'react';
import { GradeContext } from 'context/Context';
import { Card } from 'react-bootstrap';

const Example = () => {
    const { loId } = useContext(GradeContext);

    useEffect(() => {
        console.log('📄 Example component mounted with loId:', loId);
    }, [loId]);

    if (!loId) {
        return (
            <p style={{ fontStyle: 'italic', color: 'gray' }}>
                No learning objective selected.
            </p>
        );
    }

    const fileUrl = `https://www.eduhax.com/example/${loId}.docx`;
    const encodedUrl = encodeURIComponent(fileUrl);
    const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;

    return (
        <Card>
            <Card.Header>
                <h5>📄 Example Preview</h5>
            </Card.Header>
            <Card.Body>
                <iframe
                    title="Example Word Viewer"
                    src={viewerUrl}
                    width="100%"
                    height="600"
                    style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                />
            </Card.Body>
        </Card>
    );
};

export default Example;
